export const currencyFormatter = (value: number | bigint, options?: Intl.NumberFormatOptions) =>
  new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'narrowSymbol',
    ...options,
  }).format(value);

export const truncateKey = (key: string) =>
  `${key.substring(0, 5)}…${key.substring(key.length - 4)}`;
